// extracted by mini-css-extract-plugin
module.exports = {"lightBlueBackground":"SignUpContent_lightBlueBackground__jiRTQ"};